import { memo } from 'react';
import { IconProps } from './iconType';

export const StarIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 6 6" fill="none">
      <g clipPath="url(#clip0_1223_1624)">
        <path
          d="M3.00015 4.565L1.23679 5.55205L1.63062 3.56998L0.146973 2.19795L2.15373 1.96002L3.00015 0.125L3.84655 1.96002L5.8533 2.19795L4.36968 3.56998L4.7635 5.55205L3.00015 4.565Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1223_1624">
          <rect width={size} height={size} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

StarIcon.displayName = 'StarIcon';
